import { Modal, ModalHeader } from "reactstrap";
import { H3, P } from "../../../../../AbstractElements";
import UploadProfileForm from "./UploadProfileForm";

interface ModalProps {
  EmpNo: string;
  modal: boolean;
  toggle?: () => void;
}

const UploadProfileModal: React.FC<ModalProps> = ({ EmpNo, modal, toggle }) => {
  return (
    <>
      <Modal isOpen={modal} toggle={toggle} backdrop="static" keyboard={false}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="large-modal-header border-0">
            <H3>Upload Employee Profile</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P>Upload a clear and updated employee photo.</P>
          </ModalHeader>

          <UploadProfileForm EmpNo={EmpNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default UploadProfileModal;
